<template>
  <div
    id="balance"
    class="el-section"
    data-testid="balance-container"
  />
</template>

<script>
import { env } from '@/store'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
import mount from 'balance/App'
import { getMfeOnNavigate } from '@/utils/getMfeOnNavigate.utils'

const getInitialPath = (route, recipientIdPgm) => {
  const { path: oldPathname, query } = route

  const queryParams = new URLSearchParams(query).toString()
  const initalPath = oldPathname
    .split('/')
    .find(path => ['balance', 'withdraw', 'anticipation'].includes(path))

  return `/${initalPath}/${recipientIdPgm}?${queryParams}`
}

export default {
  name: 'RecipientsDetailsBalance',
  props: {
    recipientIdPgm: {
      type: String,
      required: true
    },
    recipientId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      unmountBalanceMfe: null
    }
  },
  computed: {
    ...mapGetters(['accountId', 'merchantId', 'account']),
    balanceEnv () {
      if (this.account?.account_type.value.toLowerCase() === 'test') {
        return 'test'
      }
      return 'live'
    }
  },
  methods: {
    setError: function (error) {
      this.$store.dispatch('SET_ERROR', error)
    },
    onNavigate (pathname, search) {
      getMfeOnNavigate(this.$route, this.$router, pathname, search)
    },
    onGoBack () {
      this.$router.go(-1)
    }
  },
  mounted () {
    const envPrefix = env ?? ''
    const token = Cookies.get(`${envPrefix}mp_tk`)

    const domEl = document.getElementById('balance')
    const prefix = this.$router.history?.base ?? ''

    const initialPath = this.$route.path
      .split('/')
      .find(path => ['balance', 'anticipation'].includes(path))
    const routeMustBe = `/${this.merchantId}/${this.accountId}/recipients/${this.recipientId}/${initialPath}/${this.recipientIdPgm}`

    if (
      !this.$route.fullPath.includes(`${initialPath}/${this.recipientIdPgm}`)
    ) {
      this.$router.push(routeMustBe)
    }

    const props = {
      initialPath: getInitialPath(this.$route, this.recipientIdPgm),
      onGoBack: this.onGoBack,
      environment: this.balanceEnv,
      onNavigate: this.onNavigate,
      routeBaseName: `${prefix}/${this.merchantId}/${this.accountId}/recipients/${this.recipientId}`,
      authProps: {
        jwt: token,
        accountId: this.accountId,
        merchantId: this.merchantId,
        recipientId: this.recipientIdPgm,
        onAuthError: error => {
          this.setError(error)
        }
      },
      url: `${process.env.VUE_APP_BALANCE_URL}`
    }

    const { onHostNavigate, unmount } = mount(domEl, props)
    this.unmountBalanceMfe = unmount

    this.$router.afterEach((to, from) => {
      const { fullPath } = to
      const [pathname, search] = fullPath.split('?')

      const basePath = `/${this.merchantId}/${this.accountId}/recipients/${this.recipientId}`
      const replacedPathname = pathname.replace(basePath, '')

      onHostNavigate(replacedPathname, search)
    })
  },
  beforeDestroy () {
    if (this.unmountBalanceMfe) {
      this.unmountBalanceMfe()
    }
  }
}
</script>
